import { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faTiktok,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { clsx } from 'clsx';
import { Input } from './input';
import * as styles from './socialHandleInput.css';

export type SocialPlatform = 'instagram' | 'youtube' | 'tiktok';

type SocialHandleInputProps = {
  platform: SocialPlatform;
  value: string;
  onValueChange: (value: string) => void;
  label: string;
  ariaLabel: string;
  testId?: string;
  autoFocus?: boolean;
  supportingText?: string;
  disabled?: boolean;
  wrapperClassName?: string;
  inputWrapperClassName?: string;
  endCta?: ReactNode;
};

const HANDLE_PLACEHOLDER = '@ yourhandle';

const platformIcon: Record<SocialPlatform, IconDefinition> = {
  instagram: faInstagram,
  youtube: faYoutube,
  tiktok: faTiktok,
};

const normalizeHandleValue = (value: string): string => {
  return value.replace(/^@+/, '');
};

const PlatformBadge = ({ platform }: { platform: SocialPlatform }) => {
  return (
    <span
      aria-hidden
      data-testid={`social-badge-${platform}`}
      className={clsx(styles.platformBadge, styles.platformBadgeBg[platform])}
    >
      <FontAwesomeIcon icon={platformIcon[platform]} />
    </span>
  );
};

export const SocialHandleInput = ({
  platform,
  value,
  onValueChange,
  label,
  ariaLabel,
  testId,
  autoFocus,
  supportingText,
  disabled,
  wrapperClassName,
  inputWrapperClassName,
  endCta,
}: SocialHandleInputProps) => {
  return (
    <Input
      aria-label={ariaLabel}
      type="text"
      label={label}
      placeholder={HANDLE_PLACEHOLDER}
      testId={testId}
      autoFocus={autoFocus}
      value={value}
      disabled={disabled}
      startCta={<PlatformBadge platform={platform} />}
      endCta={endCta}
      supportingText={supportingText}
      wrapperClassName={wrapperClassName}
      inputWrapperClassName={inputWrapperClassName}
      onChange={(event) =>
        onValueChange(normalizeHandleValue(event.currentTarget.value))
      }
    />
  );
};
